<template>
  <div class="flex flex-col relative border rounded p-2 gap-2">
    <el-form-item label="WhatsApp Phone Number" label-position="top">
      <el-input
        type="tel"
        placeholder="e.g., +1234567890"
        v-model="ruleForm.config.phone"
      >
        <template #append>
          <i class="el-icon-phone size-4" />
        </template>
      </el-input>
    </el-form-item>
    <p class="text-xs text-muted-foreground">
      Include country code (e.g., +1 for US)
    </p>
    <button
      @click="emit('remove')"
      type="button"
      class="absolute right-2 top-2 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
    >
      <i class="icon-x h-4 w-4" />
      <span class="sr-only">Close</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "EditRecipientWhatsAppItem",
  components: {},
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ruleForm: { ...this.value },
    };
  },
  watch: {
    ruleForm: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true,
    },
  },
  methods: {
    emit(event) {
      this.$emit(event);
    },
  },
};
</script>
